module.exports = __webpack_public_path__ + "img/teachforamerica-logo.aea905f2.jpg";